import React, { useState } from 'react';
import loginimage from '../../Assets/login.jpg'; // Ensure the path is correct
import bgimage from '../../Assets/bg1.jpg';
import '../Login/loginstyle.css';
import axios from 'axios';
import { baseURL } from '../../axiosInstance';
import { Link, useNavigate } from 'react-router-dom';
// import { useSession } from '../../SessionProvider';
import Swal from "sweetalert2";


function LoginComponent() {
  // const { login } = useSession();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Loading....",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const response = await axios.post(
        `${baseURL}/login`,
        { ...formData }
      );



      if (response.status === 200) {
        // alert(`Login successful: ${response?.data?.message}`);
        console.log('Login', response?.data?.data);
        sessionStorage.setItem("Authorization", response?.data?.data?.token);
        sessionStorage.setItem("email", formData?.email);
        sessionStorage.setItem("userid", response?.data?.data?.id);
        sessionStorage.setItem("providerId", response?.data?.data?.parentid)
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error?.response?.data);
      // alert(`Login failed.${error.response?.data?.error}`);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error?.response?.data?.data?.error || "Something went wrong!",
      });
    }
  };

  return (
    <div className='w-100 p-3 vh-100'>
      {/* Dynamic inline styling */}
      <div
        className='w-100 p-3 h-100 shadow-lg bg-body-tertiary rounded'
        style={{
          backgroundImage: `url(${bgimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className='w-100 p-3 h-100 d-flex bg-white shadow rounded'>
          <div
            className='w-50 d-none d-md-block shadow-lg rounded'
            style={{
              backgroundImage: `url(${loginimage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>

          <div className='w-50 d-flex justify-content-center align-items-center bg-white'>
            <div className='w-75'>
              <form onSubmit={handleLogin}>
                <h1 className='signformate'>Login</h1>

                <div className='mb-3'>
                  <label htmlFor='email' className='form-label signpara'>
                    Email
                  </label>
                  <input
                    className='form-control bg-body-white rounded inputtext'
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className='mb-3'>
                  <label htmlFor='password' className='form-label signpara'>
                    Password
                  </label>
                  <input
                    className='form-control bg-body-white rounded inputtext'
                    type='password'
                    name='password'
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className='text-end mb-3 signpara'>
                  <Link to={'/forgot-password'}>Forgot Password?</Link>
                </div>

                <div className='mb-3 signpara'>
                  <button type='submit' className='form-control btn btn-primary inputtext'>
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginComponent;
